export default {
  title: 'Belangrijke notities',
  buttons: {
    add_note: 'Notitie toevoegen',
  },
};
